import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, vShow as _vShow, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "list-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "filter-box" }
const _hoisted_4 = { class: "filter-box" }
const _hoisted_5 = { class: "filter-box" }
const _hoisted_6 = { class: "filter-box" }
const _hoisted_7 = { class: "filter-box" }
const _hoisted_8 = { class: "filter-box" }
const _hoisted_9 = { class: "filter-box" }
const _hoisted_10 = { class: "filter-box" }
const _hoisted_11 = { class: "filter-box" }
const _hoisted_12 = { class: "filter-box" }
const _hoisted_13 = { class: "filter-box" }
const _hoisted_14 = { class: "filter-box" }
const _hoisted_15 = { class: "filter-box" }
const _hoisted_16 = {
  class: "ml-10",
  style: {"display":"flex"}
}
const _hoisted_17 = { class: "status-text" }
const _hoisted_18 = { class: "split-table-layout" }
const _hoisted_19 = { class: "clearfix tab-title btn-container mt-10" }
const _hoisted_20 = { class: "tab-title_left fl" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "dialog-footer" }
const _hoisted_23 = { class: "dialog-footer" }
const _hoisted_24 = { key: 3 }
const _hoisted_25 = {
  class: "dataForm",
  style: {"margin-left":"0"}
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "dialog-footer mt-20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_CommandRender = _resolveComponent("CommandRender")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_TableList = _resolveComponent("TableList")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_TableSplitter = _resolveComponent("TableSplitter")!
  const _component_MaterialTable = _resolveComponent("MaterialTable")!
  const _component_FormComponent = _resolveComponent("FormComponent")!
  const _component_RukuFormComponent = _resolveComponent("RukuFormComponent")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_LogisticFormComponent = _resolveComponent("LogisticFormComponent")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_waves = _resolveDirective("waves")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        (!_ctx.isFilterCollapse)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_3, [
                _cache[30] || (_cache[30] = _createElementVNode("span", { class: "label" }, "采购编号", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.no,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.listQuery.no) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _cache[31] || (_cache[31] = _createElementVNode("span", { class: "label" }, "供应商", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.supplier,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.listQuery.supplier) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _cache[32] || (_cache[32] = _createElementVNode("span", { class: "label" }, "材料编号", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.materialNo,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.listQuery.materialNo) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[33] || (_cache[33] = _createElementVNode("span", { class: "label" }, "材料品牌", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.materialBrand,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.listQuery.materialBrand) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[34] || (_cache[34] = _createElementVNode("span", { class: "label" }, "材料名称", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.materialName,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.listQuery.materialName) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[35] || (_cache[35] = _createElementVNode("span", { class: "label" }, "材料型号", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.materialModel,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.listQuery.materialModel) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[36] || (_cache[36] = _createElementVNode("span", { class: "label" }, "开票状态", -1)),
                _createVNode(_component_el_select, {
                  filterable: true,
                  modelValue: _ctx.listQuery.invoiceStatus,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.listQuery.invoiceStatus) = $event)),
                  class: "filter-item",
                  placeholder: "",
                  clearable: "",
                  size: _ctx.t('table.btnSize'),
                  onChange: _ctx.handleFilter
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoiceStatusOptions, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.mark,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "size", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[37] || (_cache[37] = _createElementVNode("span", { class: "label" }, "付款状态", -1)),
                _createVNode(_component_el_select, {
                  filterable: true,
                  modelValue: _ctx.listQuery.paymentStatus,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.listQuery.paymentStatus) = $event)),
                  class: "filter-item",
                  placeholder: "",
                  clearable: "",
                  size: _ctx.t('table.btnSize'),
                  onChange: _ctx.handleFilter
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentStatusOptions, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.mark,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "size", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[38] || (_cache[38] = _createElementVNode("span", { class: "label" }, "入库状态", -1)),
                _createVNode(_component_el_select, {
                  filterable: true,
                  modelValue: _ctx.listQuery.storageStatus,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.listQuery.storageStatus) = $event)),
                  class: "filter-item",
                  placeholder: "",
                  clearable: "",
                  size: _ctx.t('table.btnSize'),
                  onChange: _ctx.handleFilter
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storageStatusOptions, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.mark,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "size", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[39] || (_cache[39] = _createElementVNode("span", { class: "label" }, "采购单状态", -1)),
                _createVNode(_component_el_select, {
                  filterable: true,
                  modelValue: _ctx.listQuery.status,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.listQuery.status) = $event)),
                  class: "filter-item",
                  placeholder: "",
                  clearable: "",
                  size: _ctx.t('table.btnSize'),
                  onChange: _ctx.handleFilter
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusOptions, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.mark,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "size", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _cache[40] || (_cache[40] = _createElementVNode("span", { class: "label" }, "登记日期", -1)),
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.listQuery.startTime,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.listQuery.startTime) = $event)),
                  type: "date",
                  placeholder: " ",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  onChange: _ctx.handleFilter,
                  size: _ctx.t('table.btnSize')
                }, null, 8, ["modelValue", "onChange", "size"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _cache[41] || (_cache[41] = _createElementVNode("span", { class: "label" }, "到", -1)),
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.listQuery.endTime,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.listQuery.endTime) = $event)),
                  type: "date",
                  placeholder: " ",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  onChange: _ctx.handleFilter,
                  size: _ctx.t('table.btnSize')
                }, null, 8, ["modelValue", "onChange", "size"])
              ])
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_15, [
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _ctx.handleFilter
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('table.search')), 1)
            ]),
            _: 1
          }, 8, ["size", "onClick"])), [
            [_directive_waves]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handleCommand('add')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('table.add')), 1)
            ]),
            _: 1
          }, 8, ["size"])), [
            [_directive_permission, { pkey: `${_ctx.permissionName}_ADD` }]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            size: _ctx.t('table.btnSize'),
            onClick: _ctx.handleReset
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('table.reset')), 1)
            ]),
            _: 1
          }, 8, ["size", "onClick"])), [
            [_directive_waves]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            size: _ctx.t('table.btnSize'),
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.isFilterCollapse = !_ctx.isFilterCollapse))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.isFilterCollapse ? '展开' : '收起'), 1)
            ]),
            _: 1
          }, 8, ["size"])), [
            [_directive_waves]
          ]),
          _createElementVNode("span", {
            class: "svg-icon cursor mr-10 ml-10",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.handleCommand('refresh')))
          }, [...(_cache[42] || (_cache[42] = [
            _createElementVNode("i", { class: "icon-tubiao-27 iconfont" }, null, -1)
          ]))]),
          _createElementVNode("span", {
            class: "svg-icon cursor",
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.handleCommand('column')))
          }, [...(_cache[43] || (_cache[43] = [
            _createElementVNode("i", { class: "icon-tubiao-28 iconfont" }, null, -1)
          ]))]),
          _createElementVNode("span", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colorTooltips, (item, index) => {
              return (_openBlock(), _createElementBlock("span", {
                key: index,
                class: "status-item"
              }, [
                _createElementVNode("span", {
                  style: _normalizeStyle({ backgroundColor: item.color }),
                  class: "status-square"
                }, null, 4),
                _createElementVNode("span", _hoisted_17, _toDisplayString(item.tooltip), 1)
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", {
          class: "split-pane-top vue-grid-item",
          style: _normalizeStyle({ height: _ctx.isSubMenuCollapse ? '100%' : `${_ctx.topHeight}px` })
        }, [
          _withDirectives((_openBlock(), _createBlock(_component_TableList, {
            ref: rf => { if (rf) _ctx.tableDataRef[0] = rf },
            dataList: _ctx.list,
            columnAllData: _ctx.columnAllData,
            tableName: _ctx.TableName,
            permissionName: _ctx.permissionName,
            tableRowClassName: _ctx.tableRowClassName,
            showSelection: true,
            showSummary: true,
            isShowPagination: false,
            handleDefaultWidth: 130,
            highlightCurrentRow: true,
            layoutHeight: true,
            newHpx: _ctx.newHpx,
            canRefresh: false,
            canChangeColumn: false,
            style: {"height":"calc(100% )","overflow":"hidden"},
            onRowClick: _ctx.handleRowClick,
            onCommandChange: _ctx.handleCommand
          }, {
            "operation-action": _withCtx((scope) => [
              (!(['换货单', '采购单'].includes(scope.row.type) && scope.row.type.fee === 0))
                ? (_openBlock(), _createBlock(_component_CommandRender, {
                    key: 0,
                    scopeRow: scope.row,
                    codeList: _ctx.btnList,
                    permissionName: _ctx.permissionName,
                    onCommandChange: _ctx.handleCommand
                  }, null, 8, ["scopeRow", "codeList", "permissionName", "onCommandChange"]))
                : _createCommentVNode("", true),
              (['换货单', '采购单'].includes(scope.row.type) && scope.row.type.fee === 0 && scope.row.type.paid === 0)
                ? (_openBlock(), _createBlock(_component_el_link, {
                    key: 1,
                    class: "mr-10",
                    href: "javascript:void(0)",
                    type: "danger",
                    onClick: ($event: any) => (_ctx.handleCommand('delete', scope.row))
                  }, {
                    default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                      _createTextVNode(" 删除 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            containsRate: _withCtx((scope) => [
              _createElementVNode("span", null, _toDisplayString(scope.row.containsRate ? '是' : '否'), 1)
            ]),
            deliverStatus: _withCtx((scope) => [
              _createElementVNode("span", null, _toDisplayString(['换货单', '退货单'].includes(scope.row.type) ? '' : scope.row.deliverStatus), 1)
            ]),
            _: 1
          }, 8, ["dataList", "columnAllData", "tableName", "permissionName", "tableRowClassName", "newHpx", "onRowClick", "onCommandChange"])), [
            [_directive_loading, _ctx.listLoading]
          ]),
          _withDirectives(_createVNode(_component_el_pagination, {
            class: "mt-20",
            total: _ctx.total,
            currentPage: _ctx.listQuery.page,
            "onUpdate:currentPage": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.listQuery.page) = $event)),
            "page-size": _ctx.listQuery.size,
            "page-sizes": _ctx.pageSizes,
            onSizeChange: _ctx.handleSizeChange,
            onCurrentChange: _ctx.handleCurrentChange,
            layout: "total, sizes, prev, pager, next"
          }, null, 8, ["total", "currentPage", "page-size", "page-sizes", "onSizeChange", "onCurrentChange"]), [
            [_vShow, _ctx.total > 0]
          ])
        ], 4),
        (!_ctx.isSubMenuCollapse && _ctx.tabList.length)
          ? (_openBlock(), _createBlock(_component_TableSplitter, {
              key: 0,
              onDragStart: _ctx.handleSplitterDragStart,
              onDragMove: _ctx.handleSplitterDragMove,
              onDragEnd: _ctx.handleSplitterDragEnd
            }, null, 8, ["onDragStart", "onDragMove", "onDragEnd"]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", {
          class: "split-pane-bottom",
          style: _normalizeStyle({ height: `${_ctx.bottomHeight}px` })
        }, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("ul", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabList, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.id,
                  class: _normalizeClass({ active: _ctx.activeTab === item.id }),
                  onClick: ($event: any) => (_ctx.handleTabClick(item))
                }, _toDisplayString(item.name), 11, _hoisted_21))
              }), 128))
            ])
          ]),
          (_ctx.activeTab === 1)
            ? (_openBlock(), _createBlock(_component_MaterialTable, {
                key: 0,
                materialData: _ctx.detailList
              }, null, 8, ["materialData"]))
            : _createCommentVNode("", true),
          (_ctx.activeTab === 2)
            ? (_openBlock(), _createBlock(_component_MaterialTable, {
                key: 1,
                materialData: _ctx.rukuDetailList,
                mode: "storage"
              }, null, 8, ["materialData"]))
            : _createCommentVNode("", true)
        ], 4), [
          [_vShow, !_ctx.isSubMenuCollapse && _ctx.tabList.length]
        ])
      ])
    ], 512), [
      [_vShow, !_ctx.dialogFormVisible && !_ctx.rukuFormVisible && !_ctx.logisticFormVisible && !_ctx.returnBackVisible]
    ]),
    (_ctx.dialogFormVisible)
      ? (_openBlock(), _createBlock(_component_FormComponent, {
          key: 0,
          id: _ctx.activeId,
          dialogFormVisible: _ctx.dialogFormVisible,
          api: 'purchase',
          commandState: _ctx.commandState,
          "onUpdate:visibel": _cache[17] || (_cache[17] = () => _ctx.dialogFormVisible = false),
          onSubmit: _cache[18] || (_cache[18] = ($event: any) => (_ctx.handleSubmit(_ctx.formData)))
        }, null, 8, ["id", "dialogFormVisible", "commandState"]))
      : _createCommentVNode("", true),
    (_ctx.rukuFormVisible)
      ? (_openBlock(), _createBlock(_component_RukuFormComponent, {
          key: 1,
          id: _ctx.activeId,
          api: 'purchase',
          commandState: _ctx.commandState,
          "onUpdate:visibel": _cache[19] || (_cache[19] = () => _ctx.rukuFormVisible = false),
          onSubmit: _cache[20] || (_cache[20] = ($event: any) => (_ctx.handleSubmit(_ctx.formData)))
        }, null, 8, ["id", "commandState"]))
      : _createCommentVNode("", true),
    (_ctx.logisticFormVisible)
      ? (_openBlock(), _createBlock(_component_LogisticFormComponent, {
          key: 2,
          api: "logistics",
          dialogFormVisible: _ctx.logisticFormVisible,
          purchasDetail: _ctx.activeRow,
          sendFlag: 2,
          selectcSourceId: _ctx.activeRow.id * 1,
          "onUpdate:visibel": _cache[21] || (_cache[21] = () => _ctx.logisticFormVisible = false),
          onSubmit: _cache[22] || (_cache[22] = ($event: any) => (_ctx.handleSubmit()))
        }, {
          baseInfo: _withCtx(() => [
            _cache[45] || (_cache[45] = _createElementVNode("div", { class: "form-title mb-10" }, [
              _createElementVNode("span", { class: "label green" }, "采"),
              _createElementVNode("span", { class: "left" }, "采购信息")
            ], -1)),
            _createVNode(_component_el_descriptions, {
              title: "",
              class: "mb-10"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_descriptions_item, { label: "采购编号" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.activeRow.no), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "供应商" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.activeRow.supplier), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "供应商账户" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.activeRow.account?.alias), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "总费用" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$currency(_ctx.activeRow.fee)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "税率" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.activeRow.rate || 0) + "%", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "发票类型" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.activeRow.invoiceType), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["dialogFormVisible", "purchasDetail", "selectcSourceId"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.detailVisible,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.detailVisible) = $event)),
      title: "采购明细",
      width: "70%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_22, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.detailVisible = false))
          }, {
            default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
              _createTextVNode(" 关闭 ", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_MaterialTable, { materialData: _ctx.detailList }, null, 8, ["materialData"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.rukuDetailVisible,
      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.rukuDetailVisible) = $event)),
      title: "入库明细",
      width: "70%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_23, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.rukuDetailVisible = false))
          }, {
            default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
              _createTextVNode(" 关闭 ", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_MaterialTable, {
          materialData: _ctx.rukuDetailList,
          mode: "storage"
        }, null, 8, ["materialData"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.returnBackVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _cache[48] || (_cache[48] = _createElementVNode("div", { class: "form-title mb-10 mt-10" }, [
              _createElementVNode("span", { class: "label green" }, "采"),
              _createElementVNode("span", { class: "left" }, "采购信息")
            ], -1)),
            _createVNode(_component_el_descriptions, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_descriptions_item, { label: "供应商：" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.activeRow.supplier), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "供应商账户：" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.activeRow.account?.alias), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "是否含税：" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.activeRow.containsRate ? '是' : '否'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "税率：" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.activeRow.rate) + "%", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "发票类型：" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.activeRow.invoiceType), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "付款周期：" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.activeRow.payCycle), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "发货方式：" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.activeRow.delivery), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_MaterialTable, {
            materialData: _ctx.detailList,
            ref: "returnBackRef"
          }, {
            after: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "",
                label: "操作",
                fixed: "right",
                "min-width": "100"
              }, {
                default: _withCtx(({ row }) => [
                  _createVNode(_component_el_link, {
                    type: "primary",
                    onClick: ($event: any) => (_ctx.handleAddComand(row))
                  }, {
                    default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                      _createTextVNode("添加", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["materialData"]),
          _createVNode(_component_el_form, {
            ref: "dataForm",
            model: _ctx.ruleForm,
            rules: _ctx.rules,
            "label-position": "top",
            "label-width": "100px",
            class: "mb-20 mt-20"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ruleForm.changeArray, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "border-container"
                  }, [
                    _createVNode(_component_el_form_item, {
                      label: "物料编号",
                      prop: 'changeArray.' + index + '.materialNo'
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: item.materialNo,
                          "onUpdate:modelValue": ($event: any) => ((item.materialNo) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["prop"]),
                    _createVNode(_component_el_form_item, {
                      label: "物料名称",
                      prop: 'changeArray.' + index + '.materialName'
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: item.materialName,
                          "onUpdate:modelValue": ($event: any) => ((item.materialName) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["prop"]),
                    (_ctx.isReturn)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          label: "退货数量",
                          prop: 'changeArray.' + index + '.issueAmount',
                          rules: [{ required: true, message: '请填写必填项', trigger: 'change' }]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: item.issueAmount,
                              "onUpdate:modelValue": ($event: any) => ((item.issueAmount) = $event),
                              onInput: _cache[27] || (_cache[27] = ($event: any) => (_ctx.handleInput($event, _ctx.row))),
                              type: "number",
                              min: 0
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1032, ["prop"]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createVNode(_component_el_form_item, {
                            label: "换货数量",
                            prop: 'changeArray.' + index + '.issueAmount',
                            rules: [{ required: true, message: '请填写必填项', trigger: 'change' }]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: item.issueAmount,
                                "onUpdate:modelValue": ($event: any) => ((item.issueAmount) = $event),
                                type: "number",
                                min: 0
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1032, ["prop"]),
                          _createVNode(_component_el_form_item, {
                            label: "换货单价",
                            prop: 'changeArray.' + index + '.changeFee',
                            rules: [{ required: true, message: '请填写必填项', trigger: 'change' }]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input_number, {
                                modelValue: item.changeFee,
                                "onUpdate:modelValue": ($event: any) => ((item.changeFee) = $event),
                                type: "number",
                                min: 0,
                                precision: 2,
                                "controls-position": "right"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1032, ["prop"])
                        ], 64)),
                    _createVNode(_component_el_form_item, {
                      label: "是否出库",
                      prop: 'changeArray.' + index + '.outbound'
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_checkbox, {
                          modelValue: item.outbound,
                          "onUpdate:modelValue": ($event: any) => ((item.outbound) = $event),
                          label: ""
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["prop"]),
                    (_ctx.ruleForm.changeArray[index]?.storages && _ctx.ruleForm.changeArray[index].storages.length && item.outbound)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 2,
                          label: "出货库存位置",
                          prop: 'changeArray.' + index + '.locationId'
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              filterable: true,
                              modelValue: item.locationId,
                              "onUpdate:modelValue": ($event: any) => ((item.locationId) = $event),
                              class: "filter-item",
                              placeholder: "输入关键字搜索",
                              clearable: true,
                              onChange: ($event: any) => (_ctx.handleLocationChange($event, item, index))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ruleForm.changeArray[index].storages, (storage) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: storage.location.id,
                                    label: `${storage.location.name}/${storage.location.location}`,
                                    value: storage.location.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                          ]),
                          _: 2
                        }, 1032, ["prop"]))
                      : _createCommentVNode("", true),
                    (item.locationId)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                          _createVNode(_component_el_form_item, {
                            label: "已入库数量",
                            rules: [{ required: true, message: '请填写必填项', trigger: 'change' }]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: item.selectLocation.amount,
                                "onUpdate:modelValue": ($event: any) => ((item.selectLocation.amount) = $event),
                                type: "number",
                                min: 0
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_form_item, {
                            label: "库存数量",
                            rules: [{ required: true, message: '请填写必填项', trigger: 'change' }]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: item.selectLocation.availableAmount,
                                "onUpdate:modelValue": ($event: any) => ((item.selectLocation.availableAmount) = $event),
                                type: "number",
                                min: 0
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1024)
                        ], 64))
                      : _createCommentVNode("", true),
                    _createElementVNode("i", {
                      onClick: ($event: any) => (_ctx.handleChangeDelete(item, index)),
                      class: "delete-icon"
                    }, null, 8, _hoisted_26)
                  ]))
                }), 128)),
                _createVNode(_component_el_form_item, {
                  label: "备注",
                  prop: "mark",
                  class: "fullWidth"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.ruleForm.mark,
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.ruleForm.mark) = $event)),
                      type: "textarea",
                      class: "filter-item",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"]),
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_el_button, {
              onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.returnBackVisible = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('table.cancel')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.handleReturnSubmit
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('table.confirm')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.dialogFormVisible && !_ctx.rukuFormVisible && !_ctx.logisticFormVisible && !_ctx.returnBackVisible)
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 4,
          type: "primary",
          circle: "",
          onClick: _ctx.handleSubMenuCollapse,
          class: "subMenuCollapseBtn"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.isSubMenuCollapse ? '展开' : '收起'), 1)
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true)
  ]))
}